export class Constants {
  public static authPrefix = 'auth';
}

export const AppRoles = {
  Admin: 'Admin',
  Auctioneer: 'Auctioneer',
  Buyer: 'Buyer',
  Consigner: 'Consigner',
  Purebred: 'Purebred',
  UserAdmin: 'UserAdmin',
  AdvertisementAdmin: 'AdvertisementAdmin',
  BannerAdmin: 'BannerAdmin',
  Inspector: 'Inspector'
};

export const AllAccessRoles = [AppRoles.Admin];
